export default "__VITE_ASSET__70bea56d__"